import { toArdoqError } from '@ardoq/common-helpers';
import { FlexBox } from '@ardoq/layout';
import { ErrorState } from '@ardoq/status-ui';
import { connect } from '@ardoq/rxbeach';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { t, type WithI18nLocale } from '@ardoq/i18n';
import { map } from 'rxjs';

/**
 * Design is WIP, but this is a placeholder for the error message
 * that will be shown when a visualization fails to render.
 * It should be replaced with a more informative message and more appropriate actions in the future.
 */
const VisualizationsErrorMessageBase = ({ i18nLocale }: WithI18nLocale) => (
  <FlexBox
    align="center"
    justify="center"
    width="full"
    height="full"
    backgroundColor="surfaceDefault"
  >
    <ErrorState
      layout="vertical"
      role="alert"
      title={t(
        i18nLocale,
        'tabview:visualizationError.title',
        'Unable to display visualization'
      )}
      error={toArdoqError({
        error: new Error('Visualization failed to render'),
        userMessage: t(
          i18nLocale,
          'tabview:visualizationError.message',
          'We cannot display this visualization correctly due to an unexpected error. Please try seeing your data in other visualizations.'
        ),
      })}
    />
  </FlexBox>
);

const visualizationsErrorMessageViewModel$ = i18nLocale$.pipe(
  map((i18nLocale): WithI18nLocale => ({ i18nLocale }))
);

export const VisualizationsErrorMessage = connect(
  VisualizationsErrorMessageBase,
  visualizationsErrorMessageViewModel$
);
